import { EnergyType } from '@shared/generated/models/EnergyType';

/*
 * Subset of `EnergyType` values that represent actual energy sources.
 *
 * The full enum may include non-energy values (for example `NONE` and `TOTAL`)
 * that are intentionally excluded here. Because of that, checks against EnergyType
 * can return `false` for valid enum members that are not true energy types.
 */
const VALID_ENERGY_TYPES = new Set<EnergyType>([
  EnergyType.ELECTRIC,
  EnergyType.NATURAL_GAS,
  EnergyType.OIL,
  EnergyType.PROPANE,
  EnergyType.BIOMASS
]);

export const isEnergyType = (value: unknown): value is EnergyType => {
  return (
    typeof value === 'string' && VALID_ENERGY_TYPES.has(value as EnergyType)
  );
};
